<template>
  <div class="welcome">
    <div class="wrapper">
      <div class="container" id="main">
        <div class="left">
          <div class="content">
            <h1>Erasmus+ Subsidiewijzer</h1>
            <p>Kom er achter welke subsidie het beste aansluit bij jouw wensen door het beantwoorden van een aantal vragen.</p>
            <router-link
              to="/sector"
              title="Start subsidiewijzer"
              class="button"
              >Start subsidiewijzer</router-link
            >
          </div>
        </div>
        <div class="right">
          <div class="content">
            <div class="bg" v-lazy:background-image="home"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      home: ""
    };
  },
  created() {
    function check_webp_feature(feature, callback) {
      let kTestImages = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha:
          "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation:
          "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
      };
      let img = new Image();
      img.onload = function() {
        let result = img.width > 0 && img.height > 0;
        callback(feature, result);
      };
      img.onerror = function() {
        callback(feature, false);
      };
      img.src = "data:image/webp;base64," + kTestImages[feature];
    }
    check_webp_feature("lossy", (feature, isSupported) => {
      if (isSupported) {
        this.home = require("../assets/home.png.webp");
      } else {
        this.home = require("../assets/home.png");
      }
    });
  }
};
</script>

<style lang="scss" scoped>
@use "sass:math";
@import "../style/vars";

.welcome {
  .button {
    display: block;
    padding: math.div($base-padding, 1.5);
    border-radius: $base-padding;
    margin-top: $base-padding;
    margin-bottom: $base-padding;
    @media (min-width: $breakpoint-xl) {
      width: calc(100% - #{$base-padding * 1.34});
      margin-top: ($base-padding * 2);
      margin-bottom: 0;
    }
  }
  .container {
    display: flex;
    flex-wrap: wrap;
    @media (min-width: $breakpoint-xl) {
      display: block;
    }
    .left {
      order: 1;
    }
    .right {
      .content {
        .bg {
          position: absolute;
          top: 0;
          right: -$base-padding;
          width: calc(100% + #{$base-padding * 2});
          height: 100%;
          background-position: top center;
          background-repeat: no-repeat;
          background-size: cover;
          @media (min-width: $breakpoint-xl) {
            background-position: center center;
            width: calc(100% + #{$base-padding * 2});
            height: calc(100% + #{$base-padding * 1.5});
            right: -($base-padding * 2);
            top: unset;
            bottom: -$base-padding;
          }
        }
      }
    }
  }
}
</style>
